import { editProfileReducer } from 'src/modules/profile/reducers/editProfileReducer';
import { ProfileState } from 'src/modules/profile/types/ProfileState';
import { chainReducers } from 'src/utils/chainReducers';

const defaultState: ProfileState = {
  form: {
    email: '',
    firstName: '',
    lastName: '',
    jobTitle: '',
    avatar: null,
  },
  state: null,
};

export const profileReducer = chainReducers(defaultState, [
  editProfileReducer,
]);
